var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "intro-teaser grid grid__base", class: _vm.bemFacets },
    [
      _c("div", { staticClass: "intro-teaser--container grid--container" }, [
        _c("div", { staticClass: "intro-teaser--row grid--row" }, [
          _c("div", { staticClass: "intro-teaser--col grid--col" }, [
            _vm.breadcrumb
              ? _c(
                  "div",
                  { staticClass: "intro-teaser--back-link" },
                  [
                    _c(
                      "base-btn",
                      {
                        attrs: {
                          tag: "router-link",
                          to: _vm.breadcrumb.path,
                          facets: ["has-grid", "back-link"]
                        }
                      },
                      [
                        _c("base-icon", {
                          attrs: { symbol: "arrowback", size: "medium" }
                        }),
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.breadcrumb.label) +
                            "\n                    "
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("h1", { staticClass: "intro-teaser--title" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.title) +
                  "\n                "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "intro-teaser--description" }, [
              _vm._v(_vm._s(_vm.lead))
            ]),
            _vm._v(" "),
            _vm.link_left || _vm.link_right
              ? _c(
                  "div",
                  { staticClass: "intro-teaser--buttons" },
                  [
                    _vm.link_left
                      ? _c(
                          "base-btn",
                          {
                            staticClass: "intro-teaser--button",
                            attrs: {
                              tag: "router-link",
                              to: _vm.link_left.path,
                              facets: ["primary"]
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.link_left.label) +
                                "\n                    "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.link_right
                      ? _c(
                          "base-btn",
                          {
                            staticClass: "intro-teaser--button",
                            attrs: {
                              tag: "router-link",
                              to: _vm.link_right.path,
                              facets: ["secondary"]
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.link_right.label) +
                                "\n                    "
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ebfa2910", { render: render, staticRenderFns: staticRenderFns })
  }
}